import type { SVGProps } from 'react'
const SvgSyArrowDownSystem = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="m13.3 18 7-7 1.8 1.8L12 22.9l-10.1-10 1.8-1.8 7 7V1h2.6z" />
	</svg>
)
export default SvgSyArrowDownSystem
